<template>
  <v-footer fixed padless class="font-weight-medium caption">
    <v-row justify="space-between" class="mx-0 px-4 px-sm-5 pb-2 pb-sm-3 fill-height">
      <v-col cols="4" md="2" class="pl-0 pl-md-5 pb-0 pt-0">
        <transition name="fade" mode="out-in">
          <ContactUsIcon v-if="menuOpen" />
          <ChapterProgress v-else-if="$route.meta.chapter && !$root.projectContentsOpen" />
          <div class="pb-12 pb-md-0 back-button" @click="onBackClick" v-else-if="$root.projectContentsOpen">
            <CircleBack class="circle-back"/><h4 class="back-text" v-translate>Back</h4>
          </div>
        </transition>
      </v-col>
      <v-col cols="4" md="2" class="text-center pa-0">
        <transition name="fade">
          <div class="scroll-bg ma-0 text-center" v-if="$route.meta.chapter && !menuOpen && !$root.preloader.visible && !$root.projectContentsOpen">
            <p class="scrolldown">|</p>
            <h6 class="scrolldown-copy">scroll</h6>
          </div>
        </transition>
      </v-col>
      <v-col cols="4" md="2" class="text-right pa-0">
        <!-- <IconSound /> -->
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
// import IconSound from '@/atoms/IconSound'
import ContactUsIcon from '@/atoms/ContactUsIcon'
import CircleBack from '@/assets/svg/circle-back.svg'
import ChapterProgress from '@/atoms/ChapterProgress'

export default {
  name: 'Footer',

  components: {
    // IconSound,
    CircleBack,
    ContactUsIcon,
    ChapterProgress
  },

  props: {
    menuOpen: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    onBackClick () {
      if (this.$root.projectContentsOpen && this.$root.projectContentsOpen.from) {
        if (this.$route.name !== this.$root.projectContentsOpen.from.name) {
          this.$router.replace(this.$root.projectContentsOpen.from)
        }
      }
      this.$events.emit('set-project-contents-open', false)
      // this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">

.v-footer {
  pointer-events: none;

  height: 45px;

  z-index: 5;

  @include breakpoint('md-and-up') {
    height: 55px;
  }
}

.circle-back {
  width: 36px;
  height: 36px;

  cursor: pointer;
  pointer-events: all;
  display: inline-block;
  vertical-align: middle;
  transition: transform 0.25s;

  @include breakpoint('sm-and-down') {
    transform: translateY(-36px);
  }
}

.back-text {
  display: inline-block;
  font-size: 16px;
  line-height: 36px;
  vertical-align: middle;
  margin-left: 10px;

  @include breakpoint('sm-and-down') {
    display: none;
  }
}

.back-button {
  cursor: pointer;

  &:hover {
    .back-text {
      color: $c-dark-grey;
    }

    .circle-back {
      transform: translateX(-4px);

      path,
      circle {
        stroke: $c-dark-grey;
      }
    }
  }
}

h5 {
  pointer-events: all;
}

.scroll-bg {
  display: inline-block;
  width: 40px;
  height: 20px;
  text-align: center;
}

.scrolldown {
  position: absolute;
  margin-left: 18px;

  animation: scrollAnimation 1s infinite;
  // background-color: $c-grey;
}

.scrolldown-copy {
  background-color: $c-gradient-bg;
  text-align: center;
  margin-left: 0;
  transform: translateY(20px);
  font-family: Barlow;
}

@keyframes scrollAnimation {
  0% { transform: translateY(0); }
  100% { transform: translateY(-15px); }
}
</style>
